<template>
  <section
    class="relative w-full flex flex-col justify-center items-center bg-themeComponentBg-light font-rubik cities-served-outer-container"
    :class="{ 'products-page': page === 'products' }"
    aria-labelledby="cities-served-heading"
  >
    <img
      src="@/images/cities-served/mobile-icon-01.svg"
      alt=""
      class="mobile-icon-01 1240-bp:hidden"
      aria-hidden="true"
    />

    <div class="w-full mx-5 max-w-1216" style="z-index: 2;">
      <h2 id="cities-served-heading" class="cities-served-title text-center">
        Cities served <br />
        by
        <span class="highlight">
          {{ organization ? organization.name : 'Container Alliance' }}
        </span>
      </h2>

      <nav
        class="flex flex-col 1240-bp:flex-row flex-wrap items-center justify-center"
        aria-label="List of cities we serve"
      >
        <ul class="flex flex-wrap items-center justify-center">
          <li
            v-for="(city, index) in visibleCities"
            :key="index"
            class="flex 1240-bp:flex-row flex-col"
          >
            <a :href="cityPath(city)" class="city-item min-w-298 max-w-298">
              <span>
                {{ truncateCityName(`${city.name}, ${city.stateId.toUpperCase()}`) }}
              </span>
              <img
                class="h-4"
                src="@/images/cities-served/arrow-outward.svg"
                alt=""
                aria-hidden="true"
              />
            </a>

            <button
              v-if="visibleCities.length === index + 1 && pageInfo.hasNextPage"
              @click="loadMoreCities"
              class="load-more-btn min-w-298 max-w-298"
              type="button"
              aria-label="Load more cities"
            >
              <span>{{ loading ? 'Loading...' : 'Load more' }}</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </section>
</template>

<script>
import { graphqlQuery } from 'shared/graphql'
import { citiesServed } from 'shared/graphql/queries'
import { cityPath } from '../../shared/city-helper'

export default {
  props: {
    page: {
      required: false,
      type: String
    },
    organization: {
      required: false,
      type: Object
    }
  },
  data() {
    return {
      visibleCities: [],
      pageInfo: {
        endCursor: null,
        hasNextPage: true
      },
      loading: false,
      citiesToShow: 19
    }
  },
  created() {
    this.fetchCitiesServed()
  },
  methods: {
    cityPath,
    async fetchCitiesServed(afterCursor = null) {
      this.loading = true
      try {
        const organizationId = this.organization ? this.organization.id : '1'
        const response = await graphqlQuery({
          fetchPolicy: 'no-cache',
          query: citiesServed,
          variables: {
            organizationId,
            first: afterCursor ? 20 : this.citiesToShow,
            after: afterCursor
          }
        })

        const citiesData = response.data.cities
        this.visibleCities = [...this.visibleCities, ...citiesData.edges.map(edge => edge.node)]
        this.pageInfo = citiesData.pageInfo
      } catch (error) {
        console.error('Error while fetching cities served:', error)
      } finally {
        this.loading = false
      }
    },

    loadMoreCities() {
      if (this.pageInfo.hasNextPage) {
        this.fetchCitiesServed(this.pageInfo.endCursor)
      }
    },

    truncateCityName(name) {
      return name.length > 30 ? name.substring(0, 30) + '...' : name
    }
  }
}
</script>


<style scoped>
.cities-served-outer-container {
  padding: 112px 0px;
}

.products-page {
  margin-top: 32px;
  margin-bottom: 112px;
}

.cities-served-title {
  font-size: 40px;
  font-weight: 400;
  line-height: 44px;
  letter-spacing: -0.04em;
  margin-bottom: 50px;
  color: #33415599;
}

.highlight {
  font-weight: 600;
  color: black;
  font-size: 40px;
  font-weight: 400;
  line-height: 44px;
  letter-spacing: -0.04em;
}

.cities-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2px;
}

.city-item {
  background-color: #EEECE9;
  padding: 10px 15px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 42px;
  margin: 2px;
  font-size: 14px;
  color: black !important;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease; 
}

.city-item img {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 50%;
}

.city-item:hover img {
  background-color: white;
  transform: rotate(45deg);
  box-shadow: 0 0 0 1px white;
}

.load-more-btn {
  background-color: #D4CBBF;
  padding: 10px 15px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  margin: 2px;
  font-size: 14px;
  color: black;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease; 
}

.load-more-btn:hover {
  background-color: #bfb7ac;
  color: black;
}

.mobile-icon-01 {
  position: absolute;
  top: 110px;
  left: 0px;
  z-index: 3;
}

.mobile-icon-02 {
  position: absolute;
  top: 750px;
  left: 2.5%;
  z-index: 3;
}

.mobile-icon-03 {
  position: absolute;
  top: 1050px;
  left: 2.5%;
  z-index: 3;
}

.desktop-icon-01 {
  position: absolute;
  top: 250px;
  left: 37%;
  z-index: 3;
}

.desktop-icon-02 {
  position: absolute;
  top: 160px;
  left: 30%;
  z-index: 3;
}

.desktop-icon-03 {
  position: absolute;
  top: 100px;
  left: 60%;
  z-index: 3;
}

/* Notebook screens */
@media only screen and (max-width: 1850px) {
  .desktop-icon-01 {
    position: absolute;
    top: 250px;
    left: 30%;
    z-index: 3;
  }

  .desktop-icon-02 {
    position: absolute;
    top: 160px;
    left: 22%;
    z-index: 3;
  }

  .desktop-icon-03 {
    position: absolute;
    top: 100px;
    left: 65%;
    z-index: 3;
  }
}

/* mobile */
@media(max-width: 1240px) {
  .cities-served-outer-container {
    padding: 24px 0px;
  }

  .cities-served-title {
    font-size: 32px;
    font-weight: 400;
    line-height: 38.4px;
    letter-spacing: -0.04em;
  }

  .highlight {
    font-weight: 600;
    color: #4D84FF;
  }

  .city-item {
    min-width: 320px;
    max-width: 327px;
  }

  .load-more-btn {
    min-width: 320px;
    max-width: 327px;
  }

  .products-page {
    margin-bottom: 64px;
  }
}
</style>
